import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=4de88a7b&scoped=true"
import script from "./date-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-input.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./date-input.vue?vue&type=style&index=0&id=4de88a7b&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de88a7b",
  null
  
)

export default component.exports